import { FunctionComponent } from 'react';
import { faCodeBranch } from '@fortawesome/pro-duotone-svg-icons';
import { ConfigurationType, IConfigurationVersion, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';


const ConfigurationFormVersion: FunctionComponent<IConfigurationVersion & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        formVersionPropertyPath,
        formVersionMetadata,
        isGlobalConfiguration,
        isTrialConfiguration
    } = item;

    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            spacing={isGlobalConfiguration ? 8 : 16}
            basePropertyPath={formVersionPropertyPath!}
            edit
            expandable
            enableable={!isTrialConfiguration && !isGlobalConfiguration}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Version]}
            title={formVersionMetadata?.name ?? 'Unknown Version'}
            type="Version"
            typeIcon={faCodeBranch}
            item={item}
        />
    );
}

export default ConfigurationFormVersion;